import { ComplexTable } from '@synergy/table';
import { Col, Flex, Row } from 'antd';
import i18next, { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { containerMiddlewareAdEPorto } from '../../../../server/constants.api';
import useFetch from '../../../../server/useFetch';
import { PageContent, PageSection, PageTitle } from '../../../../styles/global/Pages.styled';
import { Text } from '../../Atomics/Text';
import { CumulativeAndComparativeAnalysis } from '../../Molecules/Analytic/CumulativeAndComparativeAnalysis';
import { FiltersAnalysis } from '../../Molecules/Analytic/FiltersAnalysis';
import { GeneralCumulativeAnalysis } from '../../Molecules/Analytic/GeneralCumulativeAnalysis';

export const AnalyticWarper = ({ classes, types, tableConfigurations, currentTab, blockSideBar }) => {
    // Initializing state variables
    const [userTenant] = useState(localStorage.getItem(`adeporto_tenant`));
    const [fetchedData, setFetchData] = useState(null);
    const [selectedItems, setSelectedItems] = useState(null);
    const [filtersSelected, setfiltersSelected] = useState(null);
    const limitCheckboxes = 400;
    const [tableId, setTableId] = useState(currentTab);

    const { data: tableComplexData, isLoading: tableComplexIsLoading, isFetching: isFetchingTableComplex, refetch: refetchTableComplex } = useFetch(
        'items', 'getAnalyticItems',
        {
            tenant: JSON.parse(userTenant)?.[0],
            classes: classes,
            types: types
        }, null, null, containerMiddlewareAdEPorto);

    useEffect(() => {
        refetchTableComplex();
    }, [currentTab]);

    useEffect(() => {
        blockSideBar(isFetchingTableComplex);
    }, [isFetchingTableComplex]);

    // Custom input object for ComplexTable component
    const customInput = { placeholder: t('search') }

    // Effect hook to set fetched data for complex table
    useEffect(() => {
        if (tableComplexData?.data) {
            try {
                const data = tableComplexData?.data.map((item) => {
                    const tenant = item.tenant.split('/ADEPORTO/');
                    return { ...item, class: t(item.class), tenant: tenant?.[tenant.length - 1], 
                        voltageLevel: item.voltageLevel ? item.voltageLevel : "N/A",
                        contractedPower: item.contractedPower ? item.contractedPower : "N/A",
                        energyCertificate: item.energyCertificate ? item.energyCertificate : "N/A",
                        gas: item.gas ? item.gas : "N/A",
                        energyProduction: item.energyProduction ? item.energyProduction : "N/A" };
                });
                setFetchData(data.sort((a, b) => a.tenant.localeCompare(b.tenant)));
                // logger.info('Data in the complex table changed!')
            } catch (error) {
                // logger.error('Error in useEffect trying to fetch data for table');
                console.error('(Analytic page) Error in useEffect trying to fetch data for table:', error);
                //reportError(error); // Send error report to backend
            }
        }
    }, [tableComplexData, i18next.resolvedLanguage])

    useEffect(() => {
        setTableId(currentTab + new Date().getTime());
    }, [fetchedData]);

    // Function to handle row selection in table
    const onRowSelect = (record, selected, selectedRows) => {
        try {
            setSelectedItems(selectedRows);
        } catch (error) {
            console.error('(Analytic page) Error handling table row selection:', error);
            //reportError(error); // Send error report to backend
        }
    };

    return (
        <PageContent>
            {/* Page section for filters and table */}
            <PageSection>
                {/* Flex layout for page title and filters */}
                <Flex align="center" justify="space-between">
                    {/* Page title */}
                    <PageTitle>
                        <div className="title">
                            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03' $marginBottom='s08'>{t('analytics')}</Text>
                        </div>
                    </PageTitle>
                </Flex>
                {/* Row for complex table */}
                <Row gutter={[32, 32]}>
                    <Col span={24} >
                        <ComplexTable tableId={tableId} fetchData={fetchedData} hrefLink='/home/register/registerDetail/${id}'
                            getFromChildSelectedValues={null} onRowSelect={onRowSelect} customInput={customInput}
                            language={i18next.resolvedLanguage} hasCheckbox={true} pagination={true} defaultPageSize={10} isLoading={isFetchingTableComplex}
                            tableConfiguration={tableConfigurations} limitCheckboxes={limitCheckboxes} />
                    </Col>
                </Row>
                <FiltersAnalysis selectedItems={selectedItems} filtersSelected={(values) => { setfiltersSelected(values) }} limitCheckboxes={limitCheckboxes} />
            </PageSection >
            {/* Conditional rendering of charts section */}
            {filtersSelected ?
                <PageSection >
                    <Row gutter={[32, 32]}>
                        <GeneralCumulativeAnalysis filtersSelected={filtersSelected} />
                        <CumulativeAndComparativeAnalysis filtersSelected={filtersSelected} />
                    </Row>
                </PageSection > : null}
        </PageContent>
    );
};